import { z } from 'zod'

import { DateZod, PiloteBaseRecordZod, PiloteLocationRecordZod, PiloteRegionRecordZod } from '../../common'

import { PiloteCentralOfferedRoleZod, PiloteCentralRecordZod, PiloteEveningRecordZod } from './records'

export const PiloteCentralZod = z.object({
  timestamp: DateZod.nullable().optional(),
  central: PiloteCentralRecordZod,
  evenings: z.record(z.string(), PiloteEveningRecordZod).optional().default({}),
  locations: z.record(z.string(), PiloteLocationRecordZod).optional().default({}),
  regions: z.record(z.string(), PiloteRegionRecordZod).optional().default({}),
  bases: z.record(z.string(), PiloteBaseRecordZod).optional().default({}),
  offeredCentralRoles: z.array(PiloteCentralOfferedRoleZod).nullish(),
})

export type PiloteCentral = z.infer<typeof PiloteCentralZod>
